// Live-extension snippet URL resolves through `workspaceApiBase()` so
// the tier matches whatever surface the user is viewing. Previously
// hardcoded `https://api.symbols.app/live/...` (always prod).
import { workspaceApiBase } from '../functions/workspaceApiBase.js'

export const InstallLiveExt = {
  gap: '0',
  P: {
    color: 'inactive',
    margin: '0',
    text: '{{ learn.install.addScript | polyglot }}'
  },
  CodePreviewWithTitle: {
    margin: 'Z1 0 0',
    value: (el) =>
      `<script src="${workspaceApiBase()}/live/${el.getAppKey() && el.getAppKey().split('.')[0]}"></script>`,
    Title: null,
    Buttons: {
      FrameworkSwitcher: null
    }
  }
}
